module.exports = __webpack_public_path__ + "img/05.1ad79901.png";